<template>
  <div
    class="w-max max-w-full flex items-center gap-0.5 p-0.5 rounded-lg bg-neutral-25 overflow-x-auto"
    role="tablist"
  >
    <button
      v-for="client in resolvedClients"
      :key="`mcp-client-${client.key}`"
      type="button"
      role="tab"
      class="platform-option-btn flex items-center px-1.5 py-1 rounded-md flex-shrink-0"
      :class="{ active: value === client.key }"
      :aria-selected="value === client.key"
      @click="$emit('input', client.key)"
    >
      <img
        v-if="client.icon"
        :src="client.icon"
        :alt="''"
        class="w-4 h-4 flex-shrink-0"
        width="16"
        height="16"
      >
      <BaseText
        type="label"
        size="sm"
        class="text-text-muted px-1 whitespace-nowrap"
      >
        {{ client.label }}
      </BaseText>
    </button>
  </div>
</template>

<script>
const DEFAULT_CLIENTS = [
  { key: 'claude', label: 'Claude', icon: require('@/assets/icons/mcp-platforms/claude.svg') },
  { key: 'chatgpt', label: 'ChatGPT', icon: require('@/assets/icons/mcp-platforms/chatgpt.svg') }
]

export default {
  name: 'McpClientSwitcher',
  props: {
    value: {
      type: String,
      default: 'claude'
    },
    // Optional subset/override of clients. Items need { key, label } and may
    // omit icon to fall back to the default asset for that key.
    clients: {
      type: Array,
      default: null
    }
  },
  computed: {
    resolvedClients () {
      if (!this.clients || !this.clients.length) return DEFAULT_CLIENTS
      return this.clients.map((client) => {
        const fallback = DEFAULT_CLIENTS.find((entry) => entry.key === client.key) || {}
        return {
          key: client.key,
          label: client.label || fallback.label || client.key,
          icon: client.icon || fallback.icon || null
        }
      })
    }
  }
}
</script>

<style scoped>
.platform-option-btn {
  background-color: transparent;
  box-shadow: none;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.platform-option-btn:hover:not(.active) {
  background-color: #ECEFF3;
}
.platform-option-btn.active {
  background-color: white;
  box-shadow: 0 16px 16px -8px rgba(31, 35, 38, 0.02), 0 16px 16px -8px rgba(31, 35, 38, 0.02), 0 8px 8px -4px rgba(31, 35, 38, 0.02), 0 8px 8px -4px rgba(31, 35, 38, 0.02), 0 2px 2px -1px rgba(31, 35, 38, 0.02), 0 2px 2px -1px rgba(31, 35, 38, 0.02);
}
</style>
